import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addCategory, setImage } from "../redux/slice/categoriesSlice";
import { uploadImageToFirebase } from "../libs/utils";
import AdminCategoriesTable from "./AdminTables/CategoryTable";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Typography,
  TextField,
  Button,
  Stack,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const AdminCategories: React.FC = () => {
  const dispatch: any = useDispatch();
  const [category, setCategory] = useState<string>("");
  const [localimage, setLocalImage] = useState<File | null>(null);
  const categories = useSelector((state: any) => state.categories);

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files?.length) return;

    const file = e.target.files[0];
    if (!file.type.startsWith("image/")) {
      console.error("Selected file is not an image");
      return;
    }

    setLocalImage(file);
  };

  const handleAddCategory = async () => {
    if (category.trim() === "" || !localimage) return;

    try {
      const imageUrl = await uploadImageToFirebase(localimage,'category_images');

      dispatch(setImage({ image: imageUrl }));

      let storedImages = JSON.parse(localStorage.getItem("category_images") || "[]");
      storedImages.push(imageUrl);
      localStorage.setItem("category_images", JSON.stringify(storedImages));

      const newCategory = {
        name: category,
        imageFile: localimage,
        base64Image: imageUrl,
      };

      dispatch(addCategory(newCategory));

      setCategory("");
      setLocalImage(null);
    } catch (error) {
      console.error("Error uploading image or adding category", error);
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="h6">Add New Category</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Stack spacing={2} direction="column" sx={{ maxWidth: 400 }}>
            <TextField
              label="Category Name"
              variant="outlined"
              value={category}
              onChange={(e) => setCategory(e.target.value)}
              fullWidth
            />
            <Button variant="outlined" component="label">
              Upload Category Image
              <input
                type="file"
                hidden
                onChange={handleImageChange}
                accept="image/*"
              />
            </Button>

            {localimage && (
              <Box sx={{ mt: 1 }}>
                <Typography variant="caption">Preview:</Typography>
                <img
                  src={URL.createObjectURL(localimage)}
                  alt="Category Preview"
                  style={{ width: 100, height: 100, borderRadius: 8, marginTop: 8 }}
                />
              </Box>
            )}

            <Button
              variant="contained"
              color="primary"
              onClick={handleAddCategory}
              disabled={!category || !localimage}
            >
              Add Category
            </Button>
          </Stack>
        </AccordionDetails>
      </Accordion>

      <Typography variant="h5" sx={{ mt: 5, mb: 2 }}>
        Category List
      </Typography>

      <AdminCategoriesTable />
    </Box>
  );
};

export default AdminCategories;
